var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAsiaMilesLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_26864",
    "data-name": "Group 26864",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.702,
    height: 24,
    viewBox: "0 0 19.702 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2783",
    "data-name": "Rectangle 2783",
    width: 19.702,
    height: 24,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26863",
    "data-name": "Group 26863",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37775",
    "data-name": "Path 37775",
    d: "M.006,29.688c.058-.952,1.655-1.565,2.976-1.909a27.956,27.956,0,0,1,6.742-.732h.137c4.838,0,9.843.99,9.844,2.648l-.058.2-1.76-.511v-.119c0-.74-3.3-1.565-8.026-1.565s-8.028.825-8.028,1.565v.119l-1.749.491Z",
    transform: "translate(-0.004 -15.819)",
    fill: "#ffcb00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37776",
    "data-name": "Path 37776",
    d: "M19.7,24,9.851,0,0,24H1.507L9.851,4.917,18.194,24Z",
    transform: "translate(0 0)",
    fill: "#252f38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37777",
    "data-name": "Path 37777",
    d: "M9.86,35.2c-4.663,0-8.61-.82-9.6-2a.942.942,0,0,1-.257-.663l.051-.108,1.776-.51v.2c0,.741,3.3,1.566,8.028,1.566s8.026-.825,8.026-1.566v-.2l1.785.48.033.149c0,.955-1.6,1.568-2.949,1.913a28.991,28.991,0,0,1-6.9.734Z",
    transform: "translate(-0.002 -18.669)",
    fill: "#ffcb00"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsiaMilesLogo);
export default __webpack_public_path__ + "static/media/asia-miles-logo.30921d6cb73fd14fabbe9a531d1547b0.svg";
export { ForwardRef as ReactComponent };